import { useEffect, useReducer } from 'react'

enum Actions {
  TRAVERSE_LEFT,
  TRAVERSE_RIGHT,
  SET_KEY,
}
interface IState {
  val: string
  keys: string[]
  vertical: boolean
}
interface IKeynav extends IState {
  setVal: (val: string) => void
}

function reducer(state: IState, action: any) {
  const index = state.keys.indexOf(state.val)
  switch (action.type) {
    case Actions.SET_KEY:
      return {
        ...state,
        val: action.key,
      }
    case Actions.TRAVERSE_LEFT:
      return {
        ...state,
        val: state.keys[Math.max(0, index - 1)],
      }
    case Actions.TRAVERSE_RIGHT:
      return {
        ...state,
        val: state.keys[Math.min(state.keys.length - 1, index + 1)],
      }
  }
  return state
}

export default function useKeynav(
  keys: string[],
  onChange?: (val: string) => void,
  vertical = false
): IKeynav {
  const [data, dispatch] = useReducer(reducer, {
    val: keys[0],
    keys,
    vertical,
  })
  useEffect(() => {
    const keydown = (e: KeyboardEvent) => {
      switch (e.key) {
        case 'ArrowUp':
          if (vertical) dispatch({ type: Actions.TRAVERSE_LEFT })
          break
        case 'ArrowLeft':
          dispatch({ type: Actions.TRAVERSE_LEFT })
          break
        case 'ArrowDown':
          if (vertical) dispatch({ type: Actions.TRAVERSE_RIGHT })
          break
        case 'ArrowRight':
          dispatch({ type: Actions.TRAVERSE_RIGHT })
          break
      }
    }
    window.addEventListener('keydown', keydown)
    return () => window.removeEventListener('keydown', keydown)
  }, [vertical])
  useEffect(() => onChange?.(data.val), [data.val, onChange])

  return {
    ...data,
    setVal: (key) => dispatch({ type: Actions.SET_KEY, key }),
  }
}
